export const COOKIE_PANEL_IFRAME_ID = 'already_read'

/** 3.0 app-service.js — cookieAddr 가 있으면 숨은 iframe 으로 macromill 쿠키를 심는다. */
export function plantCookiePanel(cookieAddr) {
  if (!cookieAddr || typeof document === 'undefined') {
    return
  }
  const el = document.getElementById(COOKIE_PANEL_IFRAME_ID)
  if (el) {
    el.src = cookieAddr
    return
  }
  const iframe = document.createElement('iframe')
  iframe.id = COOKIE_PANEL_IFRAME_ID
  iframe.name = COOKIE_PANEL_IFRAME_ID
  iframe.title = 'cookie-panel'
  iframe.width = '0'
  iframe.height = '0'
  iframe.setAttribute('frameBorder', '0')
  iframe.style.display = 'block'
  iframe.style.width = '0'
  iframe.style.height = '0'
  iframe.style.border = '0'
  iframe.src = cookieAddr
  document.body.appendChild(iframe)
}
